import { BreakingCarousel, BreakingMobile } from "./BreakingCarousel";
import { LeadStory } from "./LeadStory";
import { MarketImpact } from "./MarketImpact";
import { MoreBreakingRail } from "./MoreBreakingRail";
import { OnchainIntelStrip } from "./OnchainIntelStrip";
import { AssetsToWatch } from "./AssetsToWatch";
import { H3 } from "./h3";
import { useV2Markets } from "../useV2Data";

/* Hero 3.0 — Figma source authority 214:4 (1440) · implementation authorities
   200:3 / 204:3 / 205:3 / 206:3. Composition from Figma, every value from
   live NewsLayer services. */
const fmtET = (iso?: string | null) => {
  if (!iso) return null;
  const d = new Date(iso);
  if (isNaN(d.getTime())) return null;
  const t = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", hour: "numeric", minute: "2-digit" }).format(d);
  const dt = new Intl.DateTimeFormat("en-US", { timeZone: "America/New_York", month: "short", day: "numeric", year: "numeric" }).format(d);
  return `${t} ET, ${dt}`;
};

/* Hero footer strip (214:4 y=795) — truthful last-updated only; the Figma
   "Customize" control is omitted (no such function exists yet). */
const HeroFooterStrip = () => {
  const { data: mkts } = useV2Markets();
  const t = fmtET(mkts?.updated_at);
  if (!t) return null;
  return (
    <div data-testid="h3-hero-footer" className="hidden xl:flex items-center justify-between mt-[8px] px-[14px]">
      <span className="nl-mono text-[9px] leading-[13px]" style={{ color: H3.gray }} data-testid="h3-last-updated">
        Last updated: {t}
      </span>
      <span className="nl-mono text-[9px] leading-[13px]" style={{ color: H3.gray }}>
        All data is real-time and sourced from trusted onchain and market data providers.
      </span>
      <span aria-hidden className="w-[80px]" />
    </div>
  );
};

export const Hero30 = ({ data }: { data: any }) => {
  const hero = data?.hero;
  const carousel = data?.breaking_carousel || [];
  const rail = data?.breaking_rail || [];
  const latest = data?.latest || [];
  const lens = data?.lens;
  return (
    <section data-testid="h3-hero" className="pt-[10px]">
      <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1070fr)_minmax(0,324fr)] gap-[10px]">
        <div className="min-w-0 flex flex-col gap-[10px]">
          <BreakingMobile items={carousel} />
          <BreakingCarousel items={carousel} />
          <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,760fr)_minmax(0,298fr)] gap-[10px] xl:gap-[12px] flex-1 min-w-0">
            <LeadStory hero={hero} />
            {hero && <MarketImpact hero={hero} lens={lens} />}
          </div>
        </div>
        <MoreBreakingRail rail={rail} latest={latest} />
      </div>
      <div className="mt-[10px] xl:mt-[8px]">
        <OnchainIntelStrip />
      </div>
      <div className="mt-[10px] xl:mt-[11px]">
        <AssetsToWatch />
      </div>
      <HeroFooterStrip />
    </section>
  );
};
